import api from "./axios";

export const getWorkspaceMembers = () => api.get("/workspace-members");
export const createWorkspaceMember = (data) => api.post("/workspace-members", data);
export const updateWorkspaceMemberRole = (userId, role) =>
  api.patch(`/workspace-members/${userId}/role`, { role });
export const updateWorkspaceMemberStatus = (userId, isActive) =>
  api.patch(`/workspace-members/${userId}/status`, { is_active: isActive });
